import { Component, OnInit } from '@angular/core';
import { Application } from '../../shared/user.model';
import { UserService } from '../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { Search } from '../../shared/user.model';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';


@Component({
  selector: 'app-bundle-reports',
  templateUrl: './bundle-reports.component.html',
  styleUrls: ['./bundle-reports.component.css']
})
export class BundleReportsComponent implements OnInit {

  r :  any  = {};
  RecordList : any = {};
  BundleNodisplay : number = 0 ;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute,private errorHandler: ErrorHandler,
    private formBuilder:ReactiveFormsModule, private fb : FormBuilder ) { }
  

  ngOnInit() {
  }

  GetList(Bn){
    document.getElementById('loader-spinner').style.display = "block";     
      //GetAllBundleReports
   
   this.userService.GetAllBundleReports(Bn.value.BundleNo)
    .subscribe(
      (data:any) =>{            
        this.RecordList = data.Result; 
        this.BundleNodisplay = Bn.value.BundleNo; 
         
        document.getElementById('loader-spinner').style.display = "none";                      
      }, (error) => {         
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }
    )  
  }

  myFunction(){
    window.print();
  }

}



// WEBPACK FOOTER //
// ./src/app/Godown/bundle-reports/bundle-reports.component.ts